import { RootState } from '../rmsStore';

export function getFilterReducer(state: RootState): FilterDataState {
  return state.filterReducer;
}